export const isUzairPopupVisible = state => state.uzairPopup && state.uzairPopup.is_visible;
